const KEY = "ADMIN_OPERATION_TYPES";

export const DATA_REQUEST = `DATA_${KEY}_REQUEST`;
export const DATA_SUCCESS = `DATA_${KEY}_SUCCESS`;
export const DATA_ERROR = `DATA_${KEY}_ERROR`;
